import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Card, PageHead } from '../components/ui';

export default function Home() {
    const { accounts } = useMsal();
    const name = accounts[0]?.name || '';

    return (
        <>
            <PageHead>
                <div>
                    <h2>Bienvenue{name ? ` ${name}` : ''}</h2>
                    <p>Gestion des utilisateurs, appareils et groupes Microsoft 365 du groupe Constellation.</p>
                </div>
            </PageHead>
            <Card>
                Utilisez la navigation à gauche pour rechercher un utilisateur, lancer une
                recherche avancée ou consulter le dashboard.
            </Card>
        </>
    );
}
